// extracted by mini-css-extract-plugin
module.exports = {"hero":"TheHero_hero_2H9SS","background":"TheHero_background_3vhmc","inner":"TheHero_inner_2KS0s","title":"TheHero_title_2n4rH","lead":"TheHero_lead_1PI5K"};